import { LegalDocumentKeySchema } from "@iec-id/shared/contracts/legal";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { LegalSection } from "@/components/legal/legal-section";

/**
 * Правовой центр с сразу открытым документом — `/legal/<key>`.
 *
 * Адрес нужен ссылкам ИЗВНЕ: сервисы экосистемы ведут человека на конкретный
 * текст («открыть в IEC ID» рядом со своей копией документа), и такая ссылка
 * обязана открывать документ, а не список. До 23.08.2026 маршрута не было
 * вовсе, и `/legal/privacy-policy` попадал в `notFoundComponent` витрины —
 * человек видел «Не удалось загрузить данные. Данные в безопасности», то есть
 * сообщение о сбое связи на месте обычной опечатки в адресе. Снаружи это
 * читалось как сломанный API: оболочка отдавала `200`, документы по tRPC
 * отвечали, ломаться было нечему (жалоба Hero).
 *
 * Публичный (без сессии) текст того же документа живёт на домене входа —
 * `auth.iec.exchange/legal/<key>`: он для писем и футеров. Здесь — личный
 * кабинет: рядом с текстом состояние согласия и кнопка «Принять».
 */
export const Route = createFileRoute("/legal/$key")({
	beforeLoad: ({ params }) => {
		// Неизвестный ключ — не ошибка, а устаревшая или битая ссылка: ведём в
		// список документов, а не на экран сбоя.
		if (!LegalDocumentKeySchema.safeParse(params.key).success) {
			throw redirect({ to: "/legal", replace: true });
		}
	},
	component: LegalDocumentScreen,
});

function LegalDocumentScreen() {
	const { key } = Route.useParams();
	const navigate = useNavigate();

	return (
		<LegalSection
			openDocument={LegalDocumentKeySchema.parse(key)}
			// Закрыли читалку — адрес обязан перестать указывать на документ,
			// иначе перезагрузка страницы откроет её снова. `replace`, чтобы
			// «назад» уводило в сервис, из которого человек пришёл по ссылке.
			onCloseDocument={() => void navigate({ to: "/legal", replace: true })}
		/>
	);
}
